import Ext from "Ext";

/**
 * "Icon" button implementation, rendered as an anchor with an icon image in the background.
 *
 * @cfg {String} cls css class(appends to the base class).
 * @cfg {String} icon icon image URL.
 * @cfg {String} linkCls css class for inner "a" element.
 */
const IconButton = Ext.extend(Ext.Button, {
    buttonSelector: "a:first",
    baseCls: "at-icon-button",
    cls: "",
    icon: "",
    linkCls: "",
    tooltip : "",
    tooltipType: "title",

    initComponent: function() {
        IconButton.superclass.initComponent.call(this);
        var templateString = '<div><a class="' + this.linkCls + '">&#160;</a></div>';
        this.template = new Ext.Template(templateString);
        this.cls = this.baseCls + " " + this.cls;
    }
});

Ext.reg('at_icon_button', IconButton);

export default IconButton;


// WEBPACK FOOTER //
// ./web/js/controls/at_icon_button.js